export default {
  default: {
    error: ``,
    success: ``,
  },
};
